// Lib
import React from 'react';

// Components
import Feather from '../../../../Feather';
import IconButton from '../../../../Button/IconButton/IconButton';

// Hooks
import useUI from '../../../../../hooks/useUI';

// Styles
import { useStyles } from './DisclaimerStyles';

const Disclaimer = ({ disclaimer, className, onClick }) => {
  const { isDesktopMode } = useUI();
  const { classes, cx } = useStyles();

  return (
    <span
      data-testid="disclaimer-container"
      className={cx(classes.disclaimer, className)}>
      {isDesktopMode ? (
        <>
          <Feather
            data-testid="disclaimer-icon"
            className={classes.infoIcon}
            nativeColor
            type="warning"
          />
          <span data-testid="disclaimer-message">{disclaimer}</span>
        </>
      ) : (
        <IconButton
          data-testid="disclaimer-button"
          startIcon={
            <Feather
              className={classes.warningIcon}
              nativeColor
              type="warning"
            />
          }
          onClick={onClick}>
          Info
        </IconButton>
      )}
    </span>
  );
};

export default Disclaimer;
